import { render, staticRenderFns } from "./AssociatedLeads.vue?vue&type=template&id=92a48488&scoped=true&"
import script from "./AssociatedLeads.vue?vue&type=script&lang=js&"
export * from "./AssociatedLeads.vue?vue&type=script&lang=js&"
import style0 from "./AssociatedLeads.vue?vue&type=style&index=0&id=92a48488&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a48488",
  null
  
)

export default component.exports